import { DARK_TOKENS } from '../../theme/index.content';

export const SIZES = {
  big: {
    trackHeight: 36,
    trackWidth: 56,
    thumbSize: 32,
    translateX: 20,
  },
  small: {
    trackHeight: 28,
    trackWidth: 44,
    thumbSize: 24,
    translateX: 16,
  },
} as const;

export const DARK_VARIANT = {
  container: {
    colorOff: `${DARK_TOKENS.tertiaryCustomBackground}1a`,
    colorOn: DARK_TOKENS.secondaryBackgroundDisabled,
  },
  child: {
    colorOff: DARK_TOKENS.whiteBackground,
    colorOn: DARK_TOKENS.primarySolidBackground,
  },
  text: {
    color: 'darkSurfacePrimary',
    subColor: 'darkSurfaceSecondary',
  },
} as const;

export const LIGHT_VARIANT = {
  container: {
    colorOff: `${DARK_TOKENS.blackBackground}2b`,
    colorOn: DARK_TOKENS.whiteBackground,
  },
  child: {
    colorOff: DARK_TOKENS.whiteBackground,
    colorOn: DARK_TOKENS.blackBackground,
  },
  text: {
    color: 'darkSurfacePrimary',
    subColor: 'darkSurfaceSecondary',
  },
} as const;
